import React from "react";
import "../ComplianceSupport.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiShield,
    FiFileText,
    FiCheckCircle,
    FiLock,
    FiSearch,
    FiDatabase,
    FiTrendingUp,
    FiAlertTriangle,
    FiClipboard,
    FiBarChart2
} from "react-icons/fi";


const ComplianceSupport = () => {


    return (

        <>

            <Header />


            <div className="compliance-page">



                {/*=====================================================
                            HERO SECTION
                ======================================================*/}


                <section className="compliance-hero">


                    <div className="container">


                        <div className="compliance-hero-content">


                            <span className="compliance-tag">

                                COMPLIANCE SUPPORT

                            </span>


                            <h1>

                                Strengthening Financial
                                <span> Compliance & Governance</span>

                            </h1>


                            <p>

                                Saivari Fintech provides comprehensive compliance
                                support services that help financial institutions
                                manage regulatory requirements, reduce risks, and
                                maintain secure and compliant operations.

                            </p>



                            <div className="compliance-buttons">


                                <a
                                    href="/contact"
                                    className="compliance-primary-btn"
                                >

                                    Get Consultation

                                </a>



                                {/* <Link
                                    to="/services"
                                    className="compliance-secondary-btn"
                                >

                                    Explore Services

                                </Link> */}


                            </div>


                        </div>


                    </div>


                </section>





                {/*=====================================================
                            BREADCRUMB
                ======================================================*/}



                <section className="compliance-breadcrumb">


                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />



                        <Link to="/solutions">
                            Solutions
                        </Link>



                        <FiChevronRight />



                        <span>
                            Compliance Support
                        </span>



                    </div>


                </section>







                {/*=====================================================
                        COMPLIANCE OVERVIEW
                ======================================================*/}



                <section className="compliance-overview">


                    <div className="container">



                        <div className="compliance-grid">





                            {/* LEFT */}


                            <div className="compliance-content">


                                <span className="section-tag">

                                    OVERVIEW

                                </span>



                                <h2>

                                    Building Stronger
                                    <span> Compliance Foundations</span>

                                </h2>




                                <p>

                                    Regulatory compliance is critical for financial
                                    organizations operating in a highly regulated
                                    environment. Our compliance support services help
                                    businesses establish effective governance,
                                    monitoring, and risk management frameworks.

                                </p>




                                <p>

                                    We assist banks, NBFCs, payment providers,
                                    insurance companies, and fintech organizations
                                    with compliance operations, documentation,
                                    reporting, monitoring, and regulatory readiness.

                                </p>





                                <div className="compliance-checks">


                                    <div>

                                        <FiCheckCircle />

                                        Regulatory Compliance Management

                                    </div>



                                    <div>

                                        <FiCheckCircle />

                                        Risk Assessment & Monitoring

                                    </div>




                                    <div>

                                        <FiCheckCircle />

                                        Policy & Documentation Support

                                    </div>



                                    <div>

                                        <FiCheckCircle />

                                        Compliance Reporting

                                    </div>



                                </div>



                            </div>








                            {/* RIGHT DASHBOARD */}



                            <div className="compliance-dashboard">


                                <div className="compliance-card">


                                    <FiShield />

                                    <h3>
                                        Governance
                                    </h3>

                                    <span>
                                        Strong Controls
                                    </span>


                                </div>




                                <div className="compliance-card">


                                    <FiFileText />

                                    <h3>
                                        Documentation
                                    </h3>

                                    <span>
                                        Policy Management
                                    </span>


                                </div>





                                <div className="compliance-card">


                                    <FiSearch />

                                    <h3>
                                        Monitoring
                                    </h3>

                                    <span>
                                        Continuous Review
                                    </span>


                                </div>





                                <div className="compliance-card">


                                    <FiLock />

                                    <h3>
                                        Security
                                    </h3>

                                    <span>
                                        Risk Protection
                                    </span>


                                </div>



                            </div>





                        </div>



                    </div>



                </section>









                {/*=====================================================
                    COMPLIANCE CAPABILITIES
                ======================================================*/}



                <section className="compliance-capabilities">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                OUR CAPABILITIES

                            </span>



                            <h2>

                                Complete Compliance
                                <span> Support Services</span>

                            </h2>



                        </div>







                        <div className="compliance-service-grid">





                            <div className="compliance-service-card">


                                <div className="compliance-icon">
                                    📋
                                </div>


                                <h3>
                                    Regulatory Compliance
                                </h3>


                                <p>

                                    Support organizations in maintaining
                                    compliance with evolving financial regulations
                                    and industry standards.

                                </p>


                            </div>





                            <div className="compliance-service-card">


                                <div className="compliance-icon">
                                    🔍
                                </div>


                                <h3>
                                    Compliance Monitoring
                                </h3>


                                <p>

                                    Continuous monitoring of compliance activities,
                                    processes, and operational controls.

                                </p>


                            </div>






                            <div className="compliance-service-card">


                                <div className="compliance-icon">
                                    📑
                                </div>


                                <h3>
                                    Policy Management
                                </h3>


                                <p>

                                    Creation, review, and maintenance of compliance
                                    policies and procedures.

                                </p>


                            </div>






                            <div className="compliance-service-card">


                                <div className="compliance-icon">
                                    ⚠️
                                </div>


                                <h3>
                                    Risk Management
                                </h3>


                                <p>

                                    Identify compliance risks and implement
                                    effective mitigation strategies.

                                </p>


                            </div>







                            <div className="compliance-service-card">


                                <div className="compliance-icon">
                                    📊
                                </div>


                                <h3>
                                    Compliance Reporting
                                </h3>


                                <p>

                                    Generate accurate reports and insights
                                    for better decision-making.

                                </p>


                            </div>






                            <div className="compliance-service-card">


                                <div className="compliance-icon">
                                    🛡
                                </div>


                                <h3>
                                    Audit Support
                                </h3>


                                <p>

                                    Prepare organizations for audits with proper
                                    documentation and compliance readiness.

                                </p>


                            </div>



                        </div>




                    </div>


                </section>











                <section className="compliance-challenges">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                CHALLENGES WE SOLVE

                            </span>


                            <h2>

                                Simplifying Complex
                                <span> Regulatory Requirements</span>

                            </h2>


                        </div>





                        <div className="challenge-grid">





                            <div>


                                <FiAlertTriangle />


                                <h3>
                                    Regulatory Complexity
                                </h3>


                                <p>

                                    Helping businesses manage changing
                                    regulations and compliance obligations.

                                </p>


                            </div>







                            <div>


                                <FiDatabase />


                                <h3>
                                    Data Management
                                </h3>


                                <p>

                                    Improving compliance data collection,
                                    tracking, and reporting.

                                </p>


                            </div>







                            <div>


                                <FiClipboard />


                                <h3>
                                    Operational Controls
                                </h3>


                                <p>

                                    Building structured processes for
                                    effective compliance management.

                                </p>


                            </div>



                        </div>



                    </div>


                </section>








                <section className="compliance-process">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                OUR APPROACH

                            </span>


                            <h2>

                                A Structured Compliance
                                <span> Management Process</span>

                            </h2>



                        </div>







                        <div className="compliance-process-grid">





                            {
                                [

                                    "Compliance Assessment",

                                    "Risk Identification",

                                    "Framework Design",

                                    "Policy Implementation",

                                    "Monitoring & Reporting",

                                    "Continuous Improvement"

                                ].map((item, index) => (


                                    <div
                                        className="compliance-process-card"
                                        key={index}
                                    >


                                        <div className="process-number">

                                            0{index + 1}

                                        </div>



                                        <h3>

                                            {item}

                                        </h3>



                                    </div>


                                ))
                            }






                        </div>



                    </div>


                </section>












                <section className="compliance-benefits">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                BENEFITS

                            </span>


                            <h2>

                                Why Choose Our
                                <span> Compliance Services</span>

                            </h2>



                        </div>







                        <div className="benefit-grid">





                            <div>

                                <FiShield />

                                <h3>
                                    Reduced Risk
                                </h3>

                                <p>
                                    Minimize compliance and operational risks.
                                </p>

                            </div>






                            <div>

                                <FiTrendingUp />

                                <h3>
                                    Better Governance
                                </h3>

                                <p>
                                    Improve transparency and control.
                                </p>

                            </div>







                            <div>

                                <FiBarChart2 />

                                <h3>
                                    Better Insights
                                </h3>

                                <p>
                                    Gain visibility into compliance performance.
                                </p>

                            </div>






                            <div>

                                <FiCheckCircle />

                                <h3>
                                    Regulatory Readiness
                                </h3>

                                <p>
                                    Stay prepared for regulatory requirements.
                                </p>

                            </div>




                        </div>




                    </div>



                </section>




            </div>



            <Footer />


        </>

    )

}


export default ComplianceSupport;